import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class SocialManagementApi {

  private service: string = '';
  private model: string = 'social-management';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  public setReport(params: any): Observable<any> {
    const method: string = 'POST';
    const model: string = this.model;
    const func: string = 'report';
    const _params: any = params || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, _params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, _params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/social-management.api.ts